import {useEffect} from 'react'
import {getCookieValue} from '@/utils/common'
import {AsiFlexCookieValues} from '../types'

const useAsiFlexCookies = (setContextCookiesValue: React.Dispatch<React.SetStateAction<any>>) => {
    useEffect(() => {
        const asiflexData = parseAsiFlexCookie()
        setContextCookiesValue((prev: any) => ({...prev, asiFlexData: asiflexData}))
    }, [setContextCookiesValue])
}

const parseAsiFlexCookie = (): AsiFlexCookieValues => {
    const asiflexDataCookie = getCookieValue('asiflexData')

    if (asiflexDataCookie) {
        try {
            const decodedData = atob(asiflexDataCookie)
            const parsed = JSON.parse(decodedData)
            return {
                asiFlexAvailableBalance: parsed.asiFlexAvailableBalance ?? null,
                asiFlexParticipantBalanceConsented:
                    parsed.asiFlexParticipantBalanceConsented ?? false
            }
        } catch (error) {
            console.error('Failed to parse asiflexData cookie:', error)
        }
    }

    const balanceCookie = getCookieValue('asiFlexAvailableBalance')
    const consentCookie = getCookieValue('asiFlexParticipantBalanceConsented')

    if (balanceCookie || consentCookie) {
        const balance = balanceCookie ? parseFloat(balanceCookie) : null
        return {
            asiFlexAvailableBalance: balance !== null && !isNaN(balance) ? balance : null,
            asiFlexParticipantBalanceConsented: consentCookie === 'true'
        }
    }

    return {
        asiFlexAvailableBalance: null,
        asiFlexParticipantBalanceConsented: false
    }
}

export default useAsiFlexCookies
